export const COVID_MESSAGE_SHOWN = "covidMessageShown";
export const CUSTOMER_VERIFICATION_DIALOG_ID = "customer-verification";
export const CACHE_STORE_KEY = "mat.ui.covid-message";
